<div class="card h-100">
    <div class="card-header" *ngIf="!isSummary">
      <div class="flex">
        <h1 class="flex-1">Constraints<app-info infoIndex="16"></app-info></h1>
      </div>
    </div>
    <div class="card-body">
        <table class="table" *ngIf="constraints.length">
            <thead>
            <tr>
                <td>Type</td>
                <td>Data</td>
                <td class="text-end number-col">Min value</td>
                <td class="text-end number-col">Max value</td>
                <td *ngIf="!isSummary"></td>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let c of constraints" [hidden]="c.id == activeCons.id">
                <td>{{c.type.name}}</td>
                <td>
                    <span *ngFor="let d of c.items" class="m-0 p-0 d-block">{{d.name}}</span>
                </td>
                <td class="text-end pe-4 number-col">{{c.min}}%</td>
                <td class="text-end pe-4 number-col">{{c.max}}%</td>
                <td *ngIf="!isSummary" class="text-end pe-4">
                  <mat-icon class="cursor-pointer text-primary" (click)="editCon(c)">edit</mat-icon>
                  <mat-icon class="cursor-pointer text-danger" (click)="deleteCon(c)">delete</mat-icon>
                </td>
            </tr>
            </tbody>
        </table>

        <div class="row pt-4" *ngIf="activeCons.type">
            <div class="col-md-2">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Type</mat-label>
                    <mat-select [(ngModel)]="activeCons.type" placeholder="Type" (ngModelChange)="onTypeChange()">
                        <mat-option *ngFor="let i of types" [value]="i.id">{{i.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <app-filter-select [label]="activeCons.type ? activeCons.type.name : 'Data'" [isFullWidth]="true" [needAllOption]="false" [isMultiple]="true" [list]="list" [model]="activeCons.items" (modelChanged)="activeCons.items = $event"></app-filter-select>
            </div>
            <div class="col-md-2">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Min value</mat-label>
                    <input matInput [(ngModel)]="activeCons.min" type="number" min="0" max="100">
                    <span matSuffix>%</span>
                </mat-form-field>
            </div>
            <div class="col-md-2">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Max value</mat-label>
                    <input matInput [(ngModel)]="activeCons.max" type="number" min="0" max="100">
                    <span matSuffix>%</span>
                </mat-form-field>
            </div>

          <div class="col-md-12 text-end mb-2" [hidden]="!activeCons.items || activeCons.items.length <= 1">
            <mat-button-toggle-group name="saveType" aria-label="Save Type">
              <mat-button-toggle value="saveEach" [checked]="activeCons.saveEach" (change)="onSaveEachChange()">Constrain individually</mat-button-toggle>
              <mat-button-toggle value="saveAll" [checked]="!activeCons.saveEach" (change)="onSaveEachChange()">Constrain as group</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
            <div class="col-md-12 text-end mb-4">
                <button mat-button (click)="saveCon()" color="primary"><mat-icon>save</mat-icon> Save</button>
                <button mat-button (click)="discardCon()"><mat-icon>close</mat-icon> Close</button>
            </div>
        </div>

        <div class="text-center" *ngIf="!activeCons.id && !isSummary">
            <button mat-flat-button color="primary" (click)="onAddConstraint()"><span class="navigation-button">+ Add constraint</span></button>
            <div class="col mt-4" *ngIf="showOptimize" >
                <button style="width: 200px" mat-flat-button color="primary" (click)="optimize.emit()"><span class="navigation-button">Optimize</span></button>
            </div>
        </div>
    </div>
</div>
